import React, {useContext} from 'react'; 
import UserContext  from '../../context/Globales/UserContext';
import {v4 as uuid } from 'uuid';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Box,
    Card,
    Divider, 
    Table,
    TableContainer,
    TableBody,
    TableCell,
    TableRow,
    makeStyles,
    TableHead,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {},
    actions: {
      justifyContent: 'flex-end'
    },
    FondoTable :{
        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 440,
        maxWidth: '100%'
      },
  }));

const TblDetalleConsultasRutModal =()=>{
    const classes = useStyles();
    const { datoICMODAL } = useContext(UserContext);
 

    
    return(
        <Card>
            

             <TableContainer className={classes.containerTable} >
                <Box >
                    <Table size="small" >
                        <TableHead className={classes.FondoTable}>
                            <TableRow>
                                <TableCell>Total consultas Registradas: {datoICMODAL.DetallesConsultasRut?.NumeroConsultas} </TableCell>
                               
                               
                            </TableRow>
                        </TableHead>
                        </Table>
                        </Box>
                        </TableContainer>
             
             
                <Divider />
            <PerfectScrollbar>
                <TableContainer className={classes.containerTable} >
                <Box >
                    <Table size="small" >
                        <TableHead className={classes.FondoTable}>
                            <TableRow>
                                <TableCell>Fecha detalle </TableCell>
                                <TableCell>Empresa</TableCell>
                               
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {datoICMODAL.DetallesConsultasRut?.DetalleConsultas.map((d)=>(
                                <TableRow  key={uuid()}>
                                    <TableCell>{d.FechaConsulta}</TableCell>
                                    <TableCell>{d.Empresa}</TableCell>
                                    
                                    
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
                </TableContainer>
            </PerfectScrollbar>
         
            </Card>

    );

};

export default TblDetalleConsultasRutModal;